if (!customElements.get('cbd-mobile-purchase')) {
  customElements.define('cbd-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = document.querySelector('main product-info');
      this.submit = this.productInfo?.querySelector('.product-form__submit');
      if (!this.productInfo || !this.submit || !('IntersectionObserver' in window)) return;
      this.price = this.querySelector('[data-cbd-mobile-price]');
      this.options = this.querySelector('[data-cbd-mobile-add]');
      this.variant = this.querySelector('[data-cbd-mobile-variant]');
      this.onClick = () => {
        const button = this.productInfo.querySelector('.product-form__submit');
        if (button && !button.disabled && button.form) button.form.requestSubmit(button);
      };
      this.options.addEventListener('click', this.onClick);
      this.update = () => {
        this.submit = this.productInfo.querySelector('.product-form__submit');
        if (!this.submit) { this.options.disabled = true; return; }
        this.options.disabled = this.submit.disabled;
        const price = this.productInfo.querySelector('[id^="price-"] .price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        const hiddenPrice = price?.closest('[id^="price-"]')?.classList.contains('visibility-hidden');
        this.price.textContent = !amount || this.submit.disabled || hiddenPrice ? this.dataset.unavailable : amount.textContent.trim();
        this.variant.textContent = [...this.productInfo.querySelectorAll('variant-selects input:checked, variant-selects select')].map((input) => input.value).join(' / ');
        const refill = this.productInfo.querySelector('cbd-refill-pack');
        if (refill?.ready) {
          const quantity = Number(refill.quantity.value) || 1;
          const variant = refill.currentVariant();
          this.options.textContent = this.submit.querySelector('span')?.textContent.trim() || this.options.textContent;
          if (variant && !this.submit.disabled && !hiddenPrice) {
            const paidQuantity = quantity - Math.floor(quantity / 6);
            this.price.textContent = refill.money.format(variant.price * paidQuantity / 100);
            if (quantity >= 6 && refill.dataset.preview === 'true') this.price.textContent += ` · ${refill.dataset.previewLabel}`;
            if (quantity > 1) this.variant.textContent += ` × ${quantity}`;
          }
        }
      };
      this.priceObserver = new MutationObserver(this.update);
      this.priceObserver.observe(this.productInfo, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'class'] });
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.hidden = entries[0].isIntersecting;
      });
      this.visibilityObserver.observe(this.submit);
      this.update();
    }
    disconnectedCallback() {
      this.priceObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.options?.removeEventListener('click', this.onClick);
    }
  });
}



